// extracted by mini-css-extract-plugin
module.exports = {"faqText":"_3Gydor4lh4FUndkOmT4fvG","question":"_1-t0QCh14_EskOFqfK5Vb7"};